import type { ComponentProps } from 'react';

import { Flex } from '@change-corgi/design-system-legacy/layout';

export const ActionBar: React.FC<ActionBarProps> = ({ children, ...rest }) => {
	return (
		<Flex
			sx={{
				backgroundColor: ['sunrise.semantic.background.base', 'transparent'],
				p: ['sunrise.4', 0],
				position: ['fixed', 'static'],
				left: [0, 'auto'],
				right: [0, 'auto'],
				bottom: [0, 'auto'],
				zIndex: 1,
			}}
			{...rest}
		>
			{children}
		</Flex>
	);
};

type ActionBarProps = ComponentProps<typeof Flex>;
